import { defaultTo, isEmpty, isNil } from '../../utils/fp';
import valueParser from './valueParser';

export default options => value => {
  const parts = value.val.split('|');
  const label = parts.at(-1);
  const middle = parts.slice(1, -1); // R.init then R.tail: drop level and leaf
  const path = isEmpty(middle) ? null : middle;
  const level = parts.length > 1 ? Number(parts[0]) : NaN;

  return {
    ...valueParser(options)({
      val: value.val,
      label,
      count: defaultTo(0, value.count),
      order: defaultTo(0, value.order),
    }),
    // adjust the current level to build a valid parentId
    parentId: isNil(path) ? path : [level - 1, ...path].join('|'),
    level,
    path,
  };
};
